import { ProductIdPanel as ProductIdPanelComponent } from './ProductIdPanel.component';
import { connector } from './ProductIdPanel.connector';

export const ProductIdPanel = connector(ProductIdPanelComponent);
